<template>
    <div>
        <div class="col-md-8 animated slideInLeft">
             <div class="titulo-top">
                 <div class="row ">
                     <div class="col-sm-12 bg-negro">

                        <h1 v-if=" (typeof sectionID !== 'undefined' && sectionID )" v-html="'OTT :'+ ' '+descripcion"></h1>

                        <a v-if="(sectionID =='ott_vod')"  data-toggle="collapse" href="#CategoriasOTT"><i class="fa fa-angle-down" ></i></a>

                   </div>

                    <!-- <div class="col-sm-7 bg-gris" align="right">
                         <h1 class="min-menu">
                             <a data-toggle="tab" href="#contactos"><small>Contactos</small></a>
                             <a v-if="(sectionID !=='ott_summit')" data-toggle="tab" href="#empresas"><small> | Empresas</small></a>
                             <a v-if="(sectionID =='ott_vod')"  data-toggle="collapse" href="#CategoriasOTT"><i class="fa fa-angle-down" ></i></a>
                         </h1>
                     </div>-->
                 </div>


                <!--div id="CategoriasOTT" class="panel-collapse collapse">
                 <ul class="list-group" align="center">

                 <a @click="getCompanyOTT(0)" href="#empresas" data-toggle="tab">
                    <li class="list-group-item" >Todas las Empresas</li></a>
                 <a @click="getCompanyOTT(index)"  v-for="(cat,index) in categoriasOtt" if="(typeof  categoriasOtt!== 'undefined' )" href="#empresas" data-toggle="tab">
                    <li class="list-group-item" v-html="cat.Descripcion" ></li></a>
                 </ul>
               </div>-->

             </div>

             <div class="tab-top">
                 <div class="tab-content scroll-not">
                     <!-- Tab Contactos -->
                     <div id="contactos" class="tab-pane fade in active">
                         <div class="noticia" v-for="(tmp,key) in contacts" v-if=" contacts  && (typeof contacts !== 'undefined' )" >
                             <div class="row">
                                 <div class="col-md-2" align="center">
                                     <div class="imagen-tab-ne">

                                         <router-link  :to="'/contacto/'+tmp.IdContactFM" class="color" >

                                           <div class="feat-image" v-if="tmp.Images!==null" :style="{ 'background-image': 'url(https://images.produ.com/ww/'+( (tmp.Images) ? JSON.parse(tmp.Images)[0].Subfolder : '' )+'/'+( (tmp.Images) ? JSON.parse(tmp.Images)[0].path : '' )+')' }"  ></div>

                                            <div  v-if="tmp.Images==null">
                                              <img  class="feat-image" src="../../assets/images/avatar2.png">
                                           </div>
                                         </router-link>
                                     </div>
                                 </div>
                                 <div class="col-md-10">
                                     <div class="info-tabs">
                                         <router-link  :to="'/contacto/'+tmp.IdContactFM" class="color" >
                                             <h3 v-html="tmp.FirstName+' '+tmp.LastName" ></h3>
                                         </router-link>

                                         <router-link  :to="'/empresa/'+tmp.IdCompanyFM" class="color" >
                                             <h3 v-html="tmp.Title" ></h3>
                                         </router-link>

                                         <router-link  :to="'/empresa/'+tmp.IdCompanyFM" class="color" >
                                             <h3 v-html="tmp.CompanyName" ></h3>
                                         </router-link>


                                     </div>
                                 </div>
                             </div>
                         </div>

                         <!--Paginacion English news -->
                         <div align="center">
                             <h5 class="msg" v-if="contacts.length==0">No existen Contactos</h5>

                            <div v-if="total_pagesCont && (typeof total_pagesCont=='number')">
                             <ul class="pagination " >
                                <li :class="(currentPageCont-1 == 0 ) ? 'disabled' : '' "  >
                                <a @click.prevent="paginationCont('prev',total_pagesCont,currentPageCont)">&laquo;</a></li>

                                <li v-for="value in (total_pagesCont-1)" :class="(currentPageCont == value ) ? 'active' : '' "  v-if="resultSearchCounterCont>0 && contacts && (value<10+currentPageCont  && value>=currentPageCont )"   ><a    @click.prevent="currentPageCont=value;pageNumCont(currentPageCont)" v-html="value"  ></a></li>
                                <li :class="(total_pagesCont-1 == currentPageCont ) ? 'disabled' : '' " ><a @click.prevent="paginationCont('next',total_pagesCont,currentPageCont)"  v-if="resultSearchCounterCont>0 && contacts" >&raquo;</a></li>
                            </ul>
                             </div>
                         </div>
                     </div>

                     <!-- Tab Noticias -->
                      <div id="empresas" class="tab-pane fade" v-if="(sectionID !='ott_summit')">

                         <div align="center">
                             <h5 class="msg" v-if="companies.length==0">No existen Empresas </h5>

                          <div class="noticia"  v-for="(tmp,key) in companies" v-if=" companies  && (typeof companies !== 'undefined' )" >
                              <div class="row">
                                  <div class="col-md-2" align="center">
                                      <div class="imagen-tab-ne-empresa" >
                                          <router-link  :to="'/empresa'+((sectionID!=='ott_vod') ? '': 'OTT')+'/'+tmp.IdCompanyFM" class="color" >
                                              <div class="feat-image" :style="{ 'background-image': 'url(https://images.produ.com/logos/'+( (tmp.Images) ? JSON.parse(tmp.Images)[0].Subfolder : '' )+'/'+( (tmp.Images) ? JSON.parse(tmp.Images)[0].path : '' )+')' }" ></div>
                                          </router-link>
                                      </div>
                                  </div>
                                  <div class="col-md-10">
                                      <div class="info-tabs">
                                          <router-link  :to="'/empresa'+((sectionID!=='ott_vod') ? '': 'OTT')+'/'+tmp.IdCompanyFM" class="color" >
                                                <h3 v-html="tmp.CompanyName" ></h3>
                                          </router-link>
                                          <p>Tuesday, 25 de April 2018</p>
                                      </div>
                                  </div>
                              </div>
                          </div>
                        </div>
                          <!--Paginacion English news -->
                          <div align="center">
                              <ul class="pagination" v-if="companies.length > 0" >
                                 <li :class="(currentPageComp-1 == 0 ) ? 'disabled' : '' " >
                                 <a @click.prevent="paginationComp('prev',total_pagesComp,currentPageComp)" >&laquo;</a></li>

                                 <li v-for="value in (total_pagesComp)" :class="(currentPageComp == value ) ? 'active' : '' " v-if="resultSearchCounterComp>0 && companies && (value<10+currentPageComp  && value>=currentPageComp )" ><a    @click.prevent="currentPageComp=value;pageNumComp(currentPageComp)" v-html="value"></a></li>
                                 <li :class="(total_pagesComp == currentPageComp ) ? 'disabled' : '' "><a @click.prevent="paginationComp('next',total_pagesComp,currentPageComp)"   v-if="resultSearchCounterComp>0 && companies"   >&raquo;</a></li>
                             </ul>
                          </div>
                     </div>
                 </div>
             </div>
        </div>

    </div>
</template>

<script>
var resfulApi = 'https://backend.produ.com/admin/index.php/welcome/';
//var resfulApi="http://produbackend/admin/index.php/welcome/"
import axios from 'axios';

export default {
    name: 'ContentOtt',
    data() {
        return {
            contacts: [],

            resultSearchCounterCont: 0,

            currentPageCont: 1,
            query_rowsCont: 10,
            total_pagesCont: 0,
            pageSizeCont: 10,
            pageCont: 1,

            companies: [],

            resultSearchCounterComp: 0,

            currentPageComp: 1,
            query_rowsComp: 10,
            total_pagesComp: 0,
            pageSizeComp: 10,
            pageComp: 1,

            sectionsChild: [],
            sectionID: 0,
            descripcion: '',
            categoriasOtt: [],
            catOTT: 0,
            categoriaID: 'ott',
        };
    },
    created() {},
    methods: {
        moment: function() {
            return moment();
        },
        pageNumCont: async function(currPageIn) {
            await axios
                .post(resfulApi + 'getContactOtrosWWFWS', {
                    token:
                        'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                    sectionIN: this.sectionID,
                    page: currPageIn,
                    categoria: this.categoriaID,
                })
                .then(response => {
                    this.resultSearchCounterCont = 0;
                    this.total_pagesCont = 0;
                    this.contacts = response.data.result;

                    if (
                        response.data.totalRecordsCont > 0 &&
                        response.data.result
                    ) {
                        window.scrollTo(0, 0);

                        this.resultSearchCounterCont =
                            response.data.totalRecordsCont;
                        this.total_pagesCont = Math.ceil(
                            this.resultSearchCounterCont / this.query_rowsCont
                        );

                        if (
                            (this.resultSearchCounterCont %
                                this.query_rowsCont) %
                            this.query_rowsCont >
                            0
                        ) {
                            this.total_pagesCont = this.total_pagesCont + 1;
                        }
                    }

                    this.$nextTick(function() {});
                });
        },
        getContactDataBySectionsWWFWS: async function(pageIN) {
            await axios
                .post(resfulApi + 'getContactOtrosWWFWS', {
                    token:
                        'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                    sectionIN: this.sectionID,
                    page: pageIN,
                    categoria: this.categoriaID,
                })
                .then(response => {
                    this.resultSearchCounterCont = 0;
                    this.total_pagesCont = 0;
                    this.contacts = response.data.result;

                    if (
                        response.data.totalRecordsCont > 0 &&
                        response.data.result
                    ) {
                        this.resultSearchCounterCont =
                            response.data.totalRecordsCont;
                        this.total_pagesCont = Math.ceil(
                            this.resultSearchCounterCont / this.query_rowsCont
                        );

                        if (
                            (this.resultSearchCounterCont %
                                this.query_rowsCont) %
                            this.query_rowsCont >
                            0
                        ) {
                            this.total_pagesCont = this.total_pagesCont + 1;
                        }
                    }

                    this.$nextTick(function() {});
                });
        },
        pageNumComp: async function(currPageIn) {
            await axios
                .post(resfulApi + 'getCompanyDataBySectionsWWFWS', {
                    token:
                        'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                    sectionID: this.sectionID,
                    page: currPageIn,
                    categoriaID: this.categoriaID,
                })
                .then(response => {
                    this.resultSearchCounterComp = 0;
                    this.total_pagesComp = 0;
                    this.companies = response.data.result;

                    if (
                        response.data.totalRecordsComp > 0 &&
                        response.data.result
                    ) {
                        window.scrollTo(0, 0);

                        this.resultSearchCounterComp =
                            response.data.totalRecordsComp;
                        this.total_pagesComp =
                            Math.ceil(
                                this.resultSearchCounterComp /
                                    this.query_rowsComp
                            ) - 1;

                        if (
                            (this.resultSearchCounterComp %
                                this.query_rowsComp) %
                            this.query_rowsComp >
                            0
                        ) {
                            this.total_pagesComp = this.total_pagesComp + 1;
                        }
                    }

                    this.$nextTick(function() {});
                });
        },
        getCompanyDataBySectionsWWFWS: async function(pageIN, categoriaID) {
            await axios
                .post(resfulApi + 'getCompanyDataBySectionsWWFWS', {
                    token:
                        'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                    sectionID: this.sectionID,
                    page: pageIN,
                    categoriaID: categoriaID,
                })
                .then(response => {
                    this.resultSearchCounterComp = 0;
                    this.total_pagesComp = 0;
                    this.companies = response.data.result;

                    if (
                        response.data.totalRecordsComp > 0 &&
                        response.data.result
                    ) {
                        this.resultSearchCounterComp =
                            response.data.totalRecordsComp;
                        this.total_pagesComp =
                            Math.ceil(
                                this.resultSearchCounterComp /
                                    this.query_rowsComp
                            ) - 1;

                        if (
                            (this.resultSearchCounterComp %
                                this.query_rowsComp) %
                            this.query_rowsComp >
                            0
                        ) {
                            this.total_pagesComp = this.total_pagesComp + 1;
                        }
                    }

                    this.$nextTick(function() {});
                });
        },
        getDataSection: async function(sectionID) {
            this.sectionID = sectionID;
            this.getContactDataBySectionsWWFWS(
                this.sectionID,
                1,
                this.categoriaID
            );
            if (this.sectionID !== 'ott_summit')
                this.getCompanyDataBySectionsWWFWS(1, 0);
        },
        paginationCont: async function(
            direction,
            total_pagesCont,
            currentPageCont
        ) {
            if (direction == 'prev') {
                currentPageCont - 1 == 0
                    ? ''
                    : this.pageNumCont(--this.currentPageCont);
            } else {
                currentPageCont == total_pagesCont - 1
                    ? ''
                    : this.pageNumCont(++this.currentPageCont);
            }
        },
        paginationComp: async function(
            direction,
            total_pagesComp,
            currentPageComp
        ) {
            if (direction == 'prev') {
                currentPageComp - 1 == 0
                    ? ''
                    : this.pageNumComp(--this.currentPageComp);
            } else {
                currentPageComp == total_pagesComp
                    ? ''
                    : this.pageNumComp(++this.currentPageComp);
            }
        },

        getCategoriasOTTWWFWS: async function() {
            axios
                .post(resfulApi + 'getCategoriasOTTWWFWS', {
                    token:
                        'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                })
                .then(
                    response => {
                        this.categoriasOtt = response.data;
                        this.$nextTick(function() {});
                    },
                    error => {}
                );
        },
        /* getCompanyOTT:async function(categoriaID){
    $('#CategoriasOTT').removeClass('collapse in').addClass('collapse');
      this.catOTT=categoriaID;
      this.getCompanyDataBySectionsWWFWS(1,categoriaID);
    }*/
    },
    beforeMount() {},
    mounted: function() {
        this.sectionID = this.$route.params.section;
        this.getContactDataBySectionsWWFWS(1);
        this.getCategoriasOTTWWFWS();

        if (this.sectionID !== 'ott_summit')
            this.getCompanyDataBySectionsWWFWS(1, 0);

        axios
            .post(resfulApi + 'getCategoriasOTTWWFWS', {
                token:
                    'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
            })
            .then(
                response => {
                    this.sectionsChild = response.data;
                    this.descripcion =
                        response.data[this.sectionID].Descripcion;
                },
                error => {}
            );
    },
    watch: {
        '$route.params.section'(newId, oldId) {
            this.sectionID = newId;
            this.sectionOld = oldId;

            this.getContactDataBySectionsWWFWS(1);

            if (this.sectionID !== 'ott_summit')
                this.getCompanyDataBySectionsWWFWS(1, 0);

            axios
                .post(resfulApi + 'getCategoriasOTTWWFWS', {
                    token:
                        'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                })
                .then(
                    response => {
                        this.sectionsChild = response.data;
                        this.descripcion =
                            response.data[this.sectionID].Descripcion;
                    },
                    error => {}
                );
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.media-body a {
    color: #4e4e4e;
}

a:hover {
    cursor: pointer;
}
.msg {
    color: #006c8f;
}
</style>



// WEBPACK FOOTER //
// src/components/ott/Content.vue